import { get, post } from "../utils/httpService";

const SERVICE_URLS = {
  getConfigDetails: () => `/doctor/config`,
};


export const getConfigDetails = (params) => {
  return get(SERVICE_URLS.getConfigDetails(), params);
};
